import { render, staticRenderFns } from "./formDate.vue?vue&type=template&id=1278740f"
import script from "./formDate.vue?vue&type=script&lang=js"
export * from "./formDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports